import React, {useEffect} from "react";
import {connect} from 'react-redux';

//import Container from 'react-bootstrap/Container';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
//import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import Card from '@material-ui/core/Card';
//import CardActionArea from '@material-ui/core/CardActionArea';
//import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
//import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@mui/material/Typography';
import Divider from '@material-ui/core/Divider';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import HowToReg from '@mui/icons-material/HowToReg';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import GroupsIcon from '@mui/icons-material/Groups';
import SvgIcon from '@mui/material/SvgIcon';
//import Row from 'react-bootstrap/Row';
//import Col from 'react-bootstrap/Col';
//import Alert from 'react-bootstrap/Alert';
//import MuiAlert from '@material-ui/lab/Alert';
import Alert from '@mui/material/Alert';
//import DatatablePage from './DatatablePage';
import * as actions from '../store/actions/index';
import TotalsChart from './TotalsChart';

//function Alert(props) {
//    return <MuiAlert elevation={6} variant="filled" {...props} />;
//}

function UsersIcon(props) {
    return (
        <SvgIcon {...props}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
                <path d="M319.9 320c57.41 0 103.1-46.56 103.1-104c0-57.44-46.54-104-103.1-104c-57.41 0-103.1 46.56-103.1 104C215.9 273.4 262.5 320 319.9 320zM369.9 352H270.1C191.6 352 128 411.7 128 485.3C128 500.1 140.7 512 156.4 512h327.2C499.3 512 512 500.1 512 485.3C512 411.7 448.4 352 369.9 352zM512 160c44.18 0 80-35.82 80-80S556.2 0 512 0c-44.18 0-80 35.82-80 80S467.8 160 512 160zM183.9 216c0-5.449 .9824-10.63 1.609-15.91C174.6 194.1 162.6 192 149.9 192H88.08C39.44 192 0 233.8 0 285.3C0 295.6 7.887 304 17.62 304h199.5C196.7 280.2 183.9 249.7 183.9 216zM128 160c44.18 0 80-35.82 80-80S172.2 0 128 0C83.82 0 48 35.82 48 80S83.82 160 128 160zM551.9 192h-61.84c-12.8 0-24.88 3.037-35.86 8.24C454.8 205.5 455.8 210.6 455.8 216c0 33.71-12.78 64.21-33.16 88h199.7C632.1 304 640 295.6 640 285.3C640 233.8 600.6 192 551.9 192z"/>
            </svg>
        </SvgIcon>
    )
}

function TrialIcon(props){
    return (
        <SvgIcon {...props}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
                <path d="M489.1 264.9C480.5 207.5 450.5 32 392.3 32c-14 0-26.58 5.875-37.08 14c-20.75 15.87-49.62 15.87-70.5 0C274.2 38 261.7 32 247.7 32c-58.25 0-88.27 175.5-97.77 232.9C188.7 277.5 243.7 288 319.1 288S451.2 277.5 489.1 264.9zM632.9 227.7c-6.125-4.125-14.2-3.51-19.7 1.49c-1 .875-101.3 90.77-293.1 90.77c-190.9 0-292.2-89.99-293.2-90.86c-5.5-4.875-13.71-5.508-19.71-1.383c-6.125 4.125-8.587 11.89-6.087 18.77C1.749 248.5 78.37 448 319.1 448s318.2-199.5 318.1-201.5C641.5 239.6 639 231.9 632.9 227.7z"/>
            </svg>
        </SvgIcon>
    )
}

function MinistraIcon(props){
    return (
        <SvgIcon {...props}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 122.88 122.88">
                <path d="M17.89 0h88.9c8.85 0 16.1 7.24 16.1 16.1v90.68c0 8.85-7.24 16.1-16.1 16.1H16.1c-8.85 0-16.1-7.24-16.1-16.1v-88.9C0 8.05 8.05 0 17.89 0zm9.39 31.06h24.77l9.43 36.97 9.46-36.97H95.6v60.76H80.24V45.5L68.38 91.82H54.47L42.64 45.5v46.32H27.28V31.06z" fill-rule="evenodd" clip-rule="evenodd"/>
            </svg>
        </SvgIcon>
    )
}

function Dashboard(props) {

    useEffect(() => {
        props.onGetClientList(props.token);
        props.onGetCountActiveClients(props.token);
        props.onGetCountExpiredClients(props.token);
        props.onGetCountTrials(props.token);
        props.onGetCountMinistra(props.token);
        props.onGetCredits(props.token);
        props.onGetMessage(props.token);
    }, []);
    //<div>
    //<div className="lander">
    //</div>
    //</div>
    return (

            <Container maxWidth="xl">
                <Grid 
                container 
                spacing={1} 
                direction="col"
                justify="center"
                style={{ display: "flex" }}
                >
                    <Grid container spacing={2}>
                        <Grid item md={12}>
                        </Grid>
                        <Grid item md={12} sm={12} xs={12}>
                            <Typography sx={{fontSize: 17, fontWeight: 'bold'}} variant="h6" component="div">
                                Dashboard
                            </Typography>
                            <Divider />
                        </Grid>
                        <Grid item xl={2} lg={2} md={3} sm={6} xs={12}>
                        <Paper
                                elevation={5}
                                sx={{
                                    height: '120px',
                                    marginBottom: '25px',
                                    overflow: 'hidden',
                                    display: 'block',
                                    position: 'relative',
                                    flexGrow: '1',
                                    color: '#fff',
                                    backgroundColor: '#2C3E50'
                                }}
                            >
                                <Box 
                                    component="div" 
                                    sx={{
                                        diplay: 'block', 
                                        width: '80px', 
                                        height: '80px',
                                        display: 'block',
                                        float: 'left',
                                        paddingLeft: '15px',
                                        paddingTop: '35px',
                                        marginBottom: '40px',
                                        fontSize: '35px',
                                        lineHeight: '35px'

                                        }}>
                                    <AttachMoneyIcon
                                        sx={{
                                            color: '#fff',
                                            opacity: '0.1',
                                            fontSize: '110px',
                                            marginLeft: '-35px',
                                            lineHeight: '110px'
                                        }}/>
                                </Box>
                                <Box component="div" sx={{
                                    display: 'block',
                                    position: 'absolute',
                                    right: '15px',
                                    paddingRight: '15px',

                                }}>
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            paddingTop: '25px',
                                            textAlign: 'right',
                                            fontWeight: '300', 
                                            fontSize: '34px', 
                                            lineHeight: '36px',
                                            letterSpacing: '-1px',
                                            marginBottom: '0px',
                                            color: '#fff'
                                        }}
                                    >
                                        {props.credits}
                                    </Typography>
                                    <Typography
                                        sx={{
                                            fontWeight: '300', 
                                            color: '#fff',
                                            textAlign: 'right',
                                            fontSize: '16px',
                                            letterSpacing: '0px',
                                            opacity: '1'
                                        }}
                                        variant="subtitle1"
                                        color="#fff">
                                        Credits Remaining
                                    </Typography>
                                </Box>

                            </Paper>
                        </Grid>
                        <Grid item xl={2} lg={2} md={3} sm={6} xs={12}>
                        <Paper
                                elevation={5}
                                sx={{
                                    height: '120px',
                                    marginBottom: '25px',
                                    overflow: 'hidden',
                                    display: 'block',
                                    position: 'relative',
                                    flexGrow: '1',
                                    color: '#fff',
                                    backgroundColor: '#4B77BE'
                                }}
                            >
                                <Box component="div" 
                                    sx={{
                                        diplay: 'block', 
                                        width: '80px', 
                                        height: '80px',
                                        display: 'block',
                                        float: 'left',
                                        paddingLeft: '15px',
                                        paddingTop: '35px',
                                        marginBottom: '40px',
                                        fontSize: '35px',
                                        lineHeight: '35px'
                                        }}>
                                    <UsersIcon
                                        sx={{
                                            color: '#fff',
                                            opacity: '0.1',
                                            fontSize: '110px',
                                            marginLeft: '-35px',
                                            lineHeight: '110px'
                                        }}/>
                                </Box>
                                <Box component="div" sx={{
                                    display: 'block',
                                    position: 'absolute',
                                    right: '15px',
                                    paddingRight: '15px',
                                }}>
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            paddingTop: '25px',
                                            textAlign: 'right',
                                            fontWeight: '300', 
                                            fontSize: '34px', 
                                            lineHeight: '36px',
                                            letterSpacing: '-1px',
                                            marginBottom: '0px',
                                            color: '#fff'
                                        }}
                                    >
                                        {props.total_clients}
                                    </Typography>
                                    <Typography
                                        sx={{
                                            fontWeight: '300', 
                                            color: '#fff',
                                            textAlign: 'right',
                                            fontSize: '16px',
                                            letterSpacing: '0px',
                                            opacity: '1'
                                        }}
                                        variant="subtitle1"
                                        color="#fff"
                                    >
                                        All Users
                                    </Typography>
                                </Box>

                            </Paper>
                        </Grid>
                        <Grid item xl={2} lg={2} md={3} sm={6} xs={12}>
                        <Paper
                                elevation={5}
                                sx={{
                                    height: '120px',
                                    marginBottom: '25px',
                                    overflow: 'hidden',
                                    display: 'block',
                                    position: 'relative',
                                    flexGrow: '1',
                                    color: '#fff',
                                    backgroundColor: '#26C281'
                                }}
                            >
                                <Box component="div" 
                                    sx={{
                                        diplay: 'block', 
                                        width: '80px', 
                                        height: '80px',
                                        display: 'block',
                                        float: 'left',
                                        paddingLeft: '15px',
                                        paddingTop: '35px',
                                        marginBottom: '40px',
                                        fontSize: '35px',
                                        lineHeight: '35px'
                                        }}>
                                    <HowToReg
                                        sx={{
                                            color: '#fff',
                                            opacity: '0.1',
                                            fontSize: '110px',
                                            marginLeft: '-35px',
                                            lineHeight: '110px'
                                        }}/>
                                </Box>
                                <Box component="div" sx={{
                                    display: 'block',
                                    position: 'absolute',
                                    right: '15px',
                                    paddingRight: '15px',
                                }}>
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            paddingTop: '25px',
                                            textAlign: 'right',
                                            fontWeight: '300', 
                                            fontSize: '34px', 
                                            lineHeight: '36px',
                                            letterSpacing: '-1px',
                                            marginBottom: '0px',
                                            color: '#fff'
                                        }}
                                    >
                                        {props.total_active_clients}
                                    </Typography>
                                    <Typography
                                        sx={{
                                            fontWeight: '300', 
                                            color: '#fff',
                                            textAlign: 'right',
                                            fontSize: '16px',
                                            letterSpacing: '0px',
                                            opacity: '1'
                                        }}
                                        variant="subtitle1"
                                        color="#fff"
                                    >
                                        Active Users
                                    </Typography>
                                </Box>

                            </Paper>
                        </Grid>
                        <Grid item xl={2} lg={2} md={3} sm={6} xs={12}>
                        <Paper
                                elevation={5}
                                sx={{
                                    height: '120px',
                                    marginBottom: '25px',
                                    overflow: 'hidden',
                                    display: 'block',
                                    position: 'relative',
                                    flexGrow: '1',
                                    color: '#fff',
                                    backgroundColor: '#D91E18'
                                }}
                            >
                                <Box component="div" 
                                    sx={{
                                        diplay: 'block', 
                                        width: '80px', 
                                        height: '80px',
                                        display: 'block',
                                        float: 'left',
                                        paddingLeft: '15px',
                                        paddingTop: '35px',
                                        marginBottom: '40px',
                                        fontSize: '35px',
                                        lineHeight: '35px'
                                        }}>
                                    <PersonOffIcon
                                        sx={{
                                            color: '#fff',
                                            opacity: '0.1',
                                            fontSize: '110px',
                                            marginLeft: '-35px',
                                            lineHeight: '110px'
                                        }}/>
                                </Box>
                                <Box component="div" sx={{
                                    display: 'block',
                                    position: 'absolute',
                                    right: '15px',
                                    paddingRight: '15px',
                                }}>
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            paddingTop: '25px',
                                            textAlign: 'right',
                                            fontWeight: '300', 
                                            fontSize: '34px', 
                                            lineHeight: '36px',
                                            letterSpacing: '-1px',
                                            marginBottom: '0px',
                                            color: '#fff'
                                        }}
                                    >
                                        {props.total_expired_clients}
                                    </Typography>
                                    <Typography
                                        sx={{
                                            fontWeight: '300', 
                                            color: '#fff',
                                            textAlign: 'right',
                                            fontSize: '16px',
                                            letterSpacing: '0px',
                                            opacity: '1'
                                        }}
                                        variant="subtitle1"
                                        color="#fff"
                                    >
                                        Expired Users
                                    </Typography>
                                </Box>

                            </Paper>
                        </Grid>
                        <Grid item xl={2} lg={2} md={3} sm={6} xs={12}>
                        <Paper
                                elevation={5}
                                sx={{
                                    height: '120px',
                                    marginBottom: '25px',
                                    overflow: 'hidden',
                                    display: 'block',
                                    position: 'relative',
                                    flexGrow: '1',
                                    color: '#fff',
                                    backgroundColor: '#95950A'
                                }}
                            >
                                <Box component="div" 
                                    sx={{
                                        diplay: 'block', 
                                        width: '80px', 
                                        height: '80px',
                                        display: 'block',
                                        float: 'left',
                                        paddingLeft: '15px',
                                        paddingTop: '35px',
                                        marginBottom: '40px',
                                        fontSize: '35px',
                                        lineHeight: '35px'
                                        }}>
                                    <TrialIcon
                                        sx={{
                                            color: '#fff',
                                            opacity: '0.1',
                                            fontSize: '110px',
                                            marginLeft: '-35px',
                                            lineHeight: '110px'
                                        }}
                                    />
                                </Box>
                                <Box component="div" sx={{
                                    display: 'block',
                                    position: 'absolute',
                                    right: '15px',
                                    paddingRight: '15px',
                                }}>
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            paddingTop: '25px',
                                            textAlign: 'right',
                                            fontWeight: '300', 
                                            fontSize: '34px', 
                                            lineHeight: '36px',
                                            letterSpacing: '-1px',
                                            marginBottom: '0px',
                                            color: '#fff'
                                        }}
                                    >
                                        {props.total_trials}
                                    </Typography>
                                    <Typography
                                        sx={{
                                            fontWeight: '300', 
                                            color: '#fff',
                                            textAlign: 'right',
                                            fontSize: '16px',
                                            letterSpacing: '0px',
                                            opacity: '1'
                                        }}
                                        variant="subtitle1"
                                        color="#fff"
                                    >
                                        Trials
                                    </Typography>
                                </Box>

                            </Paper>
                        </Grid>
                        <Grid item xl={2} lg={2} md={3} sm={6} xs={12}>
                        <Paper
                                elevation={5}
                                sx={{
                                    height: '120px',
                                    marginBottom: '25px',
                                    overflow: 'hidden',
                                    display: 'block',
                                    position: 'relative',
                                    flexGrow: '1',
                                    color: '#fff',
                                    backgroundColor: '#4B123E' //75, 18, 62
                                }}
                            >
                                <Box component="div" 
                                    sx={{
                                        diplay: 'block', 
                                        width: '80px', 
                                        height: '80px',
                                        display: 'block',
                                        float: 'left',
                                        paddingLeft: '15px',
                                        paddingTop: '35px',
                                        marginBottom: '40px',
                                        fontSize: '35px',
                                        lineHeight: '35px'
                                        }}>
                                    <MinistraIcon
                                        sx={{
                                            color: '#fff',
                                            opacity: '0.1',
                                            fontSize: '110px',
                                            marginLeft: '-35px',
                                            lineHeight: '110px'
                                        }}/>
                                </Box>
                                <Box component="div" sx={{
                                    display: 'block',
                                    position: 'absolute',
                                    right: '15px',
                                    paddingRight: '15px',
                                }}>
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            paddingTop: '25px',
                                            textAlign: 'right',
                                            fontWeight: '300', 
                                            fontSize: '34px', 
                                            lineHeight: '36px',
                                            letterSpacing: '-1px',
                                            marginBottom: '0px',
                                            color: '#fff'
                                        }}
                                    >
                                        {props.total_ministra}
                                    </Typography>
                                    <Typography
                                        sx={{
                                            fontWeight: '300', 
                                            color: '#fff',
                                            textAlign: 'right',
                                            fontSize: '16px',
                                            letterSpacing: '0px',
                                            opacity: '1'
                                        }}
                                        variant="subtitle1"
                                        color="#fff"
                                    >
                                        Ministra
                                    </Typography>
                                </Box>
                            </Paper>
                        </Grid>                
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                            <TotalsChart role="dealer" />
                        </Grid>
                        <Grid item md={12} sm={12} xs={12}>
                                <Typography sx={{fontSize: 17, fontWeight: 'bold'}} variant="h6" component="div">
                                    Information
                                </Typography>
                                <Divider />
                            </Grid>
                        <Grid container spacing={1}>
                            <Grid item md={12} xs={12}>
                                <Alert elevation={5} variant="filled" severity="warning">{props.message}</Alert>
                            </Grid>
                            <Grid item md={12} xs={12}>
                                <Alert elevation={5} severity="success"><b>Ministra</b> player is supported! Create or Update account and select <b>Ministra</b> checkbox. The Ministra player can be downloaded on Android, iOS, AppleTV, Roku, Tizen, WebOS and Samsung Smart TV!</Alert>
                            </Grid>
                            <Grid item md={12} xs={12}>
                                <Alert elevation={5} severity="info">Click <a href="https://"><b>here</b></a> for Telegram support.</Alert>
                            </Grid>
                        </Grid> 
                    </Grid>
                </Container>

    );
}

const mapDispatchToProps = dispatch => {
    return {
        onGetClientList: (token) => dispatch(actions.clientList(token)),
        onGetCredits: (token) => dispatch(actions.creditsUser(token)),
        onGetMessage: (token) => dispatch(actions.getMessageDealer(token)),
        onGetCountActiveClients: (token) => dispatch(actions.countActiveClientsDealer(token)),
        onGetCountExpiredClients: (token) => dispatch(actions.countExpiredClientsDealer(token)),
        onGetCountTrials: (token) => dispatch(actions.countTrialsDealer(token)),
        onGetCountMinistra: (token) => dispatch(actions.countMinistraDealer(token))
    }
};

const mapStateToProps = state => {
    return {
        token: state.auth.token,
        clients: state.clients.client_list,
        total_clients: state.clients.total,
        credits: state.credits.credits,
        message: state.getMessage.message,
        total_active_clients: state.countActiveClients.total,
        total_expired_clients: state.countExpiredClients.total,
        total_trials: state.countTrials.total,
        total_ministra: state.countMinistra.total
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);